import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[locale]/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/src/src/app/globals.css");
